import { CloudAccountType } from '@repo/api-gw-sdk';

export function buildEonServiceAccountName(
  accountType: CloudAccountType,
  projectId: string,
  eonAccountId: string,
  scanningProjectId: string
): string {
  switch (accountType) {
    case CloudAccountType.Source:
      return `eon-${eonAccountId.substring(0, 16)}@${projectId}.iam.gserviceaccount.com`;
    case CloudAccountType.Restore:
      return `eon-restore-${eonAccountId.substring(0, 16)}@${projectId}.iam.gserviceaccount.com`;
    case CloudAccountType.Vault:
      return `eon-vault-${eonAccountId.substring(0, 16)}@${scanningProjectId}.iam.gserviceaccount.com`;
    case CloudAccountType.Scanning:
      return `eon-scan-${eonAccountId.substring(0, 16)}@${scanningProjectId}.iam.gserviceaccount.com`;
    default:
      throw new Error(`Unknown account type: ${accountType}`);
  }
}
